module.exports = __webpack_public_path__ + "img/picture.85396ac5.svg";